import { ReactElement } from 'react';

import { ITab } from 'coreOld/types';

import TabsNavigation from './TabsNavigation';

interface IProps {
  tabs: ITab[];
  activeTab: ITab;
  onClick: (tab: ITab) => void;
  children?: ReactElement | ReactElement[];
}

const TableTabsView = ({ tabs, onClick, children, activeTab }: IProps) => {
  return (
    <>
      <TabsNavigation tabs={tabs} onClick={onClick} activeTab={activeTab} />

      {children}
    </>
  );
};

export default TableTabsView;
